import React from "react";
import { useNavigate } from "react-router-dom";
const NaboraFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-black py-4 px-6 border-t border-white/10">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-y-6">
        <div className="flex flex-col lg:col-span-5">
          <div className="flex justify-center gap-3 mb-6">
            <span className="text-lg lg:text-2xl font-bold tracking-tighter items-center">
              📍 NABORA
            </span>
          </div>
          <p className="text-slate-200 max-w-md">
            A PurpleDoor product. Local commerce, digital inclusion, behavioral
            growth.
          </p>
          <div className="mt-4 text-sm text-slate-300">
            © 2026 Think5Whys. All rights local.
          </div>
        </div>

        <div className="lg:col-span-3 space-y-8">
          <div className="text-sm lg:text-sm space-y-2 text-slate-300">
            <div
              onClick={() => navigate("/finditlocal")}
              className="cursor-pointer hover:text-white"
            >
              FindItLocal
            </div>

            <div
              onClick={() => navigate("/nabora/exhibitions")}
              className="cursor-pointer hover:text-white"
            >
              Exhibitions
            </div>

            <div
              onClick={() => navigate("/purpledoordashboard")}
              className="cursor-pointer hover:text-white"
            >
              BOS Rewards
            </div>
          </div>
        </div>

        <div className="lg:col-span-4">
          <div className="uppercase text-xs tracking-widest mb-4 text-slate-300">
            Big platforms connect products.
            <br />
            Nabora connects neighbourhoods. ❤️
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NaboraFooter;
